export default "__VITE_PUBLIC_ASSET__2895309f__"